import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import SectionHeading from "@/components/base/SectionHeading";
import { formatViews } from "@/utils/format";

export default function HotRanking() {
  const ranked = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 8);

  return (
    <section id="hot" className="bg-background-100 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <SectionHeading
            kicker="实时热度"
            title="今日热榜"
            desc="综合讨论量、传播趋势与持续时间给出的热度参考，帮你快速定位当前最值得关注的话题。"
          />
          <span className="text-xs text-foreground-500 font-label whitespace-nowrap">
            热度数据每 30 分钟刷新
          </span>
        </div>

        <ol className="mt-8 bg-background-50 rounded-lg border border-background-200/80 divide-y divide-background-200/70 overflow-hidden">
          {ranked.map((article, index) => (
            <li key={article.id}>
              <Link
                to={`/article/${article.id}`}
                className="group flex items-center gap-4 md:gap-5 px-4 md:px-6 py-4 cursor-pointer hover:bg-primary-50/60 transition-colors"
              >
                <span
                  className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-md font-heading font-bold text-sm ${
                    index < 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {index + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <span className="inline-block text-xs font-label text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full">
                    {article.categoryName}
                  </span>
                  <h3 className="mt-1.5 font-heading font-bold text-sm md:text-base text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                </div>
                <div className="hidden sm:flex flex-col items-end gap-1.5 w-32 shrink-0">
                  <span className="text-xs text-foreground-500 font-label inline-flex items-center gap-1">
                    <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    {formatViews(article.views)}
                  </span>
                  <span className="w-full h-1.5 rounded-full bg-background-200 overflow-hidden">
                    <span
                      className="block h-full rounded-full bg-primary-500"
                      style={{ width: `${article.heat}%` }}
                    ></span>
                  </span>
                </div>
                <i className="ri-arrow-right-s-line text-xl text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}